(function ($) {
    (function () {
        const SCROLL_RETRY_DELAY = 300; // 毎回の確認インターバル（ms）
        const SCROLL_RETRY_GAP = 2; // 誤差許容(px)
        const MAX_RETRY_COUNT = 5; // 最大リトライ回数

        // 現在のヘッダー高さを取得（動的対応）
        function getHeaderHeight() {
            return $('#masthead').innerHeight() || 0;
        }

        // スクロール処理（リトライ機構付き）
        function scrollToTargetWithRetry(target, attempt = 0) {
            if (!target.length || attempt > MAX_RETRY_COUNT) return;

            let headerHeight = getHeaderHeight();
            let targetPos = target.offset().top - headerHeight;

            $('html, body').stop().scrollTop(targetPos);

            // リトライチェック
            setTimeout(() => {
                let currentScroll = $(window).scrollTop();
                let newTargetPos = target.offset().top - getHeaderHeight();

                if (Math.abs(currentScroll - newTargetPos) > SCROLL_RETRY_GAP) {
                    // まだずれているなら再トライ
                    scrollToTargetWithRetry(target, attempt + 1);
                }
            }, SCROLL_RETRY_DELAY);
        }

        // ページロード時のハッシュ対応
        const urlHash = location.hash;
        if (urlHash) {
            $('html, body').stop().scrollTop(0); // 最初にリセット
            setTimeout(() => {
                const target = $(urlHash);
                scrollToTargetWithRetry(target);
            }, 100); // 初期レンダリング待ち（画像が遅延読込中でも大丈夫）
        }

        // アンカーリンククリック時（.notscrollを除外）
        $('a[href^="#"]:not(.notscroll)').on('click', function (e) {
            e.preventDefault();
            const target = $($(this).attr('href'));
            scrollToTargetWithRetry(target);
        });
    })();

})(jQuery);
